// noinspection ES6UnusedImports

import {MsalAuthProvider, LoginType} from "react-aad-msal";
import { ENVIROMENT } from "../utilities";

const commonParameters = {
    scopes: ["openid", "profile", "user.read"],
};

const commonOptions = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: window.location.origin + "/auth.html",
};

const commonCache = {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
};


const configMX = {
    auth: {
        authority: "https://login.microsoftonline.com/fe51472c-6660-4ae5-995a-ac0f14ef2b07",
        clientId: "c7657147-6aaf-4823-a61f-98b01746067e",
        redirectUri: window.location.origin,
        validateAuthority: true,
        navigateToLoginRequestUrl: true,
    },
    cache: commonCache,
};
export const authProviderMX = new MsalAuthProvider(configMX, commonParameters, commonOptions);
console.log("Proveedor de autenticación para MX creado.");

const configEU = {
    auth: {
        authority: "https://login.microsoftonline.com/0fcc44cc-5868-4897-981e-7b04f79d61d8",
        clientId: "b3ecd430-b87f-4893-a91d-acd37a29117a",
        redirectUri: window.location.origin,
        validateAuthority: true,
        navigateToLoginRequestUrl: true,
    },
    cache: commonCache,
};
export const authProviderEU = new MsalAuthProvider(configEU, commonParameters, commonOptions);
console.log("Proveedor de autenticación para EU creado.");


export const authProvider = authProviderMX;
